const apache={
    toolsImg: require("@/assets/icon/apache.png"),
        toolsTitle: "Apache软件基金会",
        toolsTag: "基金会",
        toolsDes:"Apache软件基金会（简称为ASF），正式创建于1999年7月，是专门为支持开源软件项目而办的一个非盈利性组织。" +
            "在它所支持的Apache项目与子项目中，所发行的软件产品都遵循Apache许可证。" ,

        toolsChild:[
            {
                toolsChildId: 0,
                toolsTitle: "孵化中项目",
                cardList:[
                            {
                                cardImg:require("@/assets/icon/apache.png"),
                                cardTitle:"Amoro",
                                cardDes:"基于 Apache Iceberg 和 Apache Paimon 等开放数据湖格式构建的湖仓管理系统",
                                cardLink:"https://gitee.com/mindspore/mindspore"
                            },
                            {
                                cardImg:require("@/assets/icon/apache.png"),
                                cardTitle:"Annotator",
                                cardDes:"为浏览器、服务器和用户提供注释支持代码。",
                                cardLink:"https://gitee.com/mindspore/mindspore/tree/master/mindspore/lite"
                            },

                            {
                                cardImg:require("@/assets/icon/apache.png"),
                                cardTitle:"Bare Maps",
                                cardDes:"用于创建、发布和运营在线地图的工具包和基础设施组件集合",
                                cardLink:"https://gitee.com/mindspore/akg"
                            },
                            {
                                cardImg:require("@/assets/icon/apache.png"),
                                cardTitle:"Cloudberry",
                                cardDes:"基于最新的 PostgreSQL 内核构建，是最先进和成熟的开源大规模并行处理（MPP）数据库之一。",
                                cardLink:"https://gitee.com/mindspore/akg"
                            },
                            {
                                cardImg:require("@/assets/icon/apache.png"),
                                cardTitle:"Devlake",
                                cardDes:"是一个开发数据平台，为开发团队提供数据基础设施，以分析和提高其工程生产力。",
                                cardLink:"https://gitee.com/mindspore/akg"
                            },
                        ]
            },
            {
                toolsChildId: 1,
                toolsTitle: "已毕业项目",
                cardList:[

                ]
            },

    ],
};
export default apache;